import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useHttpGetBranchesCountFromOrganization = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [data, setData] = useState(0);
    const [isReady, setIsReady] = useState(false);

    const { exec, abort } = organizationApi.getBranchesCount({
        onSuccess: res => {
            setData(res.body.count);
        },
        onError: error => console.log(error),
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { isReady, data };
};

export default useHttpGetBranchesCountFromOrganization;
